import { lazy } from "react";

const MyPagePassword = lazy(() => import("app/pages/mypage/MyPagePassword"));
const MyPageDetail = lazy(() => import("app/pages/mypage/MyPageDetail"));
const AlarmList = lazy(() => import("app/pages/mypage/AlarmList"));

export const mpRouter: any[] = [
  {path: 'mypage', element: <MyPagePassword />},
  {path: 'mypage/:type?', element: <MyPageDetail />},

  // 알림 목록. 헤더 종 아이콘에는 최근 한 달만 보이므로 지난 알림은 여기서 찾는다.
  // 대구와 같은 주소를 쓴다 — fm 이 보내는 알림 링크(_link)가 양쪽에서 같게 동작한다.
  {path: '/alarms', element: <AlarmList />},
];